// Tipo de usuarios

export function getUserTypes() {
  return [
    { value: "ADMIN", label: "Administrador del sistema" },
    { value: "HR_ADMIN", label: "Administrador de RR. HH." },
    { value: "SUPERVISOR", label: "Supervisor" },
    { value: "EMPLOYEE", label: "Elemento" },
  ];
}

export function getUserTypeLabel(userType) {
  const type = getUserTypes().find((t) => t.value === userType);
  return type ? type.label : userType;
}